// extracted by mini-css-extract-plugin
module.exports = {"categorySection":"category-grid_categorySection__576uh","gridContainer":"category-grid_gridContainer__GVTna"};